import { Trans, useTranslation } from 'next-i18next';
import React, { FC } from 'react';
import { PATHS } from '../../constants';
import UniversalLink from '../UniversalLink';

import styles from './FavoritesNotification.module.scss';

export type FavoritesNotificationProps = {
  variant: 'added' | 'removed' | 'restore' | 'error';
  onClick?: () => void;
};

const FavoritesNotification: FC<FavoritesNotificationProps> = ({ variant, onClick }) => {
  const [t] = useTranslation('common');

  if (variant === 'restore') {
    return (
      <div>
        <Trans
          t={t}
          i18nKey={`favorites-notification--favorite-${variant}`}
          components={[
            // eslint-disable-next-line jsx-a11y/control-has-associated-label
            <button
              type="button"
              className={styles.button}
              onClick={onClick}
            />,
          ]}
        />
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <Trans
        t={t}
        i18nKey={`favorites-notification--favorite-${variant}`}
        components={[<UniversalLink href={PATHS.FAVORITES} />]}
      />
    </div>
  );
};

export default FavoritesNotification;
